import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CaseService } from '../services/case.service';

@Injectable({
  providedIn: 'root'
})
export class InitialRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private caseService: CaseService
  ) {}

  canActivate(): boolean {
    // Check if the current client is 'oriel' using the CaseService
    if (this.caseService.isClient('oriel')) {
      this.router.navigate(['/landing'], { replaceUrl: true });
    } else {
      this.router.navigate(['/login'], { replaceUrl: true });
    }
    
    return false; // Prevent the current navigation
  }
}
